import { isEmpty } from "lodash";
import * as React from "react";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { RegularDepositMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/RegularDepositMethod";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { PaymentType, regularDepositMethodArraysMap } from "../../Resource/Contents";
import { SelectBankAccount } from "../BankAccount/SelectBankAccount";

interface IRegularPaymentMethodsProps extends IProcessComponentProps {
    bankAccounts: BankAccount[];
    bankAccountInstructions: BankAccountInstruction[];
    payeeType: PaymentType;
    subAccountType: SubAccountType;
    onSaveNewBankAccountInstruction?: (BankAccountInstruction: BankAccountInstruction) => void;
    onRemoveBankAccountInstruction?: (BankAccountInstruction: BankAccountInstruction) => void;
    inUseBankAccountInstruction?: string[];
    customerId: number;
    autoLineCompleted?: boolean;
}

interface IRegularPaymentMethodsState {
    addNewBankAccount: boolean;
    onlineDeclarationConfirmed: boolean;
    showOnlineDeclarationPopup: boolean;
}

export class RegularPaymentMethods extends ProcessComponent<IRegularPaymentMethodsProps, IRegularPaymentMethodsState> {
    public static defaultProps = {
        autoLineCompleted: true,
    };
    constructor(props: any) {
        super(props);
        this.state = { addNewBankAccount: false, onlineDeclarationConfirmed: false, showOnlineDeclarationPopup: true };
    }

    componentDidMount(): void {
        if (this.props.data?.RegularPaymentMethod == RegularDepositMethod.NotSpecified) {
            this.props.onChange({ RegularPaymentMethod: RegularDepositMethod.DirectDebit });
        }
        if (!this.props.data?.BankAccountNumber) {
            this.props.onChange({ BankAccountNumber: null });
        }
    }

    public render() {
        const {
            payeeType,
            data,
            onChange,
            bankAccountInstructions,
            bankAccounts,
            subAccountType,
            onSaveNewBankAccountInstruction,
            onRemoveBankAccountInstruction,
            inUseBankAccountInstruction,
            customerId,
        } = this.props;
        const directDebitOnly = !(
            (payeeType === PaymentType.Client && subAccountType == SubAccountType.InvestmentAccount) ||
            (payeeType === PaymentType.Client && subAccountType == SubAccountType.StocksIsa)
        );
        const paymentMenthods = !directDebitOnly
            ? [RegularDepositMethod.NotSpecified, RegularDepositMethod.DirectDebit, RegularDepositMethod.ProductWrapperCash]
            : [RegularDepositMethod.NotSpecified, RegularDepositMethod.DirectDebit];

        const isFromQuote = !isEmpty(getQueryParameters()["quoteid"]);
        return (
            <>
                <div className="row">
                    <div className="col-md-4 col-12">
                        <SelectEditor
                            options={paymentMenthods}
                            getText={(v) => regularDepositMethodArraysMap[v]}
                            required="Please select Payment method"
                            selected={data?.RegularPaymentMethod}
                            label="Payment method"
                            onChange={(v) => onChange({ RegularPaymentMethod: v, BankAccountNumber: null })}
                            disabled={directDebitOnly}
                            validationRules={[
                                {
                                    errorMessage: "Please select payment method",
                                    validator: (v) => v != RegularDepositMethod.NotSpecified,
                                },
                            ]}
                            //placeholder="Please select"
                        />
                    </div>
                </div>

                {(data?.RegularPaymentMethod == RegularDepositMethod.DirectDebit ||
                    (isFromQuote && data.RegularPaymentMethod == RegularDepositMethod.NotSpecified)) && (
                    <SelectBankAccount
                        payeeType={payeeType}
                        bankAccountInstructions={bankAccountInstructions}
                        bankAccounts={bankAccounts}
                        data={data}
                        onChange={(c) => onChange(c)}
                        onRef={(ref) => this.appendChild(ref)}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        isReview={this.props.isReview}
                        onSaveNewBankAccountInstruction={onSaveNewBankAccountInstruction}
                        onRemoveBankAccountInstruction={onRemoveBankAccountInstruction}
                        inUseBankAccountInstruction={inUseBankAccountInstruction}
                        customerId={customerId}
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                )}
            </>
        );
    }
}
